import React from 'react';
import { _ } from '../../../functions/translator';

import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import { findProtocolGroup } from '../../../functions/finder';
import ProtocolTable from './protocolTable';
import { getAnswersInformation } from '../../../functions/getter';

class ProtocolInfo extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            open: true
        }
    }

    sortByOrderIndex(firstTable, secondTable) {
        return firstTable.attributes.order_index - secondTable.attributes.order_index;
    }

    render(){

        let protocolId = this.props.cardsGroup.attributes.protocol_id
        let protocolgroup = null
        if (protocolId) {
            protocolgroup = findProtocolGroup(protocolId, this.props.protocolgroups)
        }
        let protocol = protocolgroup ? protocolgroup.protocols[protocolId.toString()] : null
        let protocolName = protocol ? ' - ' + protocol.attributes.name : ''
        let protocolGroupName = protocolgroup ? protocolgroup.attributes.name + protocolName : _('Ninguno')
        
        let protocolTitle = _('Protocolo')
        if (this.props.customcard) {
            if (!this.props.customcard.attributes.protocol_id) return <div></div>
            protocolTitle = this.props.customcard.attributes.protocol_id
        }

        let iconButtonStyle = { padding: 0 }
        let iconStyle = { height: '1.5rem', width: '1.5rem' }
        let containerStyle = this.state.open ? { borderBottom: '0px'}  : { borderBottom: '1px solid #2c2e33' }
        
        let protocoltables = []
        if (protocol && this.props.card) {
            const answersData = Object.values(this.props.card.answers);
            const answersInfo = getAnswersInformation(answersData);
            const protocoltablesWithOutDeletionDate = Object.values(protocol.protocoltables).filter(p => {
                return p.attributes.deletion_date == null
            })
            const orderedProtocoltables = protocoltablesWithOutDeletionDate.sort(this.sortByOrderIndex);
            for (const protocoltableData of orderedProtocoltables) {
                console.log("answersInfo",answersInfo)
                console.log("protocoltableData",protocoltableData)
                protocoltables.push(
                    <ProtocolTable
                        answersInfo={answersInfo} 
                        protocoltableData={protocoltableData}
                    />
                )
            }
        }

        return (
            <div>
                <div className='question-container' style={ containerStyle }>
                    <p className='card-text'>{ protocolTitle }</p>
                    <span className='text card-description'>{ protocolGroupName }</span>
                    { protocolId ?
                    <IconButton color='primary' style={ iconButtonStyle } onClick={() => this.setState({ open: !this.state.open })}>
                        {this.state.open ? <KeyboardArrowUpIcon style={ iconStyle }/> : <KeyboardArrowDownIcon style={ iconStyle }/>}
                    </IconButton> :
                    <div></div> }
                    <Collapse in={ this.state.open } timeout="auto" unmountOnExit>
                        { protocoltables }
                    </Collapse>
                </div>
            </div>
        );
    }
}

export default ProtocolInfo;